import type {
  Cache,
  FieldArgs,
  Link,
  ResolveInfo,
} from '@urql/exchange-graphcache';
import { QUERY_ROOT_NAME } from './constants';

export default function linkSubscription<T extends string>(name: T) {
  return (
    parent: { [K in T]: Link },
    args: FieldArgs,
    cache: Cache,
    _info: ResolveInfo,
  ) => {
    const current = cache.resolve(QUERY_ROOT_NAME, name, args);

    if (current) {
      cache.link(QUERY_ROOT_NAME, name, args, parent[name]);
    }
  };
}
